module.exports = __webpack_public_path__ + "img/fe_backdrop_emblem_ed.2aedeae4.png";